<template>
    <v-list :dense="dense">
        <v-list-item-group multiple v-model="selected" color="primary">
            <v-list-item v-for="(l,i) in mygroups">
                <v-list-item-content>
                    <v-list-item-title>
                        {{l.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{l.data.length}} Profile<span v-if="l.data.length!==1">s</span>
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-checkbox :value="selected.includes(i)" />
                </v-list-item-action>
            </v-list-item>
        </v-list-item-group>
    </v-list>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props:['groups', 'dense'],
    name: "GroupListMultiSelect",
    components: {},
    data() {
      return {
        selected: [],
        mygroups: []
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    watch:{
      selected(n){
        let tmp = this.mygroups.filter((f,i)=>{
          if(n.includes(i)){
            return f
          }
        })
        this.$emit('click',tmp)
      }
    },
    mounted(){
      this.getAllLists()
    },
    methods: {
      ...mapActions(['get', 'post']),
      async getAllLists() {
        if(this.groups){
          this.mygroups=this.groups
        }
        let p = await this.post({path: 'api/profilesv2/getlists', body: {}})
        this.mygroups = p
      }
    }
  }

</script>

<style scoped>

</style>